import $ from 'jquery';
import datepicker from 'js-datepicker';

export const init = ($target) => {
	var $datepicker = $('.js-datepicker');

	if ($datepicker.length) {
		const picker = datepicker('.js-datepicker', {
			startDay: 1,
			customDays: ['Ne', 'Po', 'Út', 'St', 'čt', 'Pá', 'So'],
			customMonths: [
				'Leden',
				'Únor',
				'Březen',
				'Duben',
				'Květen',
				'Červen',
				'Červenec',
				'Srpen',
				'Září',
				'Říjen',
				'Listopad',
				'Prosinec',
			],
			overlayPlaceholder: 'čtyřmístný rok',
			respectDisabledReadOnly: true,
			formatter: (input, date, instance) => {
				const value = date.toLocaleDateString('cs-CZ');
				input.value = value; // => '10. 10. 2020'
			},
			onSelect: (instance, date) => {
				$(instance.el).trigger('change');
			},
		});
	}

	$target.find('.item-label').each(function () {
		var $this = $(this);
		var $text = $this.find('.inp__text, .inp__textarea');
		var $select = $this.find('.inp__select');

		$text
			.on('focus', () => {
				$this.addClass('is-filled');
			})
			.on('blur change', () => {
				if ($text.val().length || $text.val() !== '') {
					if ($this.attr('disabled', true)) {
						$this.addClass('is-disabled');
					}
					$this.addClass('is-filled');
				} else {
					$this.removeClass('is-filled');
				}
			});

		$select
			.on('focus', () => {
				$this.addClass('is-filled');
			})
			.on('blur change', () => {
				const value = $select.val().length;
				if (!value) {
					$this.removeClass('is-filled');
				} else {
					$this.addClass('is-filled');
				}
			});
		$text.trigger('change');
		$select.trigger('change');
	});
};
